import { render, staticRenderFns } from "./OrdersFilters.vue?vue&type=template&id=41e37208&"
import script from "./OrdersFilters.vue?vue&type=script&lang=js&"
export * from "./OrdersFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrdersFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports